import http, { createApi } from '@core/fetch'
import { API_SHOP_INFO } from '@constant'

export default {
  statistics: () =>
    http('/p/wedding/index.php/Admin/APIOrder/comment_statistics'),

  shopInfo: () => http(API_SHOP_INFO),

  siDaUpgrade: () =>
    http.post('/p/wedding/index.php/Admin/APIMerchant/myWorksNeedUpgrade'),

  bank: () => http('/p/wedding/Admin/APIMerchantBank/AppBindBank'),

  isAppointment: createApi(
    '/p/wedding/index.php/Admin/APIMerchant/isAppointment'
  ),

  merConsult: body =>
    http.post('/p/wedding/index.php/Admin/APIMerchant/merConsult', { body }),

  cpm_bounty_balance: () =>
    http('/p/wedding/index.php/Admin/APIBounty/cpm_bounty_balance'),

  upgradeStatus: () => http('/p/wedding/Admin/APIMerchant/upgrade_status'),

  price: () => http('/p/wedding/Admin/APIMerchantWeapp/Price'), //小程序价格
  productCoupon: createApi(
    '/p/wedding/index.php/Admin/APIMerchantCouponBuyers/DifferentProductCouponList'
  ),

  // 智优投&智推宝的显隐
  cpm_type: () => http('/p/wedding/Admin/APICpmPlan/cpm_type'),

  // 新商家成长计划模块
  getTaskSchedule: () =>
    http('/p/wedding/index.php/Admin/APIMerchantTaskDetail/taskSchedule'),

  // 获取任务
  changeScheduleStatus: () =>
    http.post('/p/wedding/index.php/Admin/APIMerchantTaskDetail/receive'),

  // 三大解绑父账号（父账号仅有一个子账号时使用）
  threeRoleUnbindParent: () =>
    http.post('/p/wedding/admin/APIMerchant/threeRoleUnbindParent'),

  // 子商家解绑父子账号
  unbindParent: body =>
    http.post('/p/wedding/admin/APIMerchant/unbindParent', { body }),

  //短信验证码
  checkMsgCode: body =>
    http.post('/p/wedding/index.php/home/APIUser/send_msg', {
      body
    })
}
